const subscription_url = {
  'development': 'ws://localhost:4000',
  'staging': 'wss://juniper-staging-api.herokuapp.com',
  'production': 'wss://api.junipertechnology.co'
}

let currentSubUrl = subscription_url[process.env.REACT_APP_ENVIRONMENT || 'development']

export default currentSubUrl